import React, { useEffect, useState } from 'react'
import { shape, string, arrayOf, func, bool } from 'prop-types'
import { createComponent, withTheme } from '@ycos/fela'
import { hasTag } from '@ycos/coremedia-renderer'
import { OptimizelyFeature } from '@ynap/optimizely-utils'
import InfoBlock from './InfoBlock'
import ImageBlock from './ImageBlock'

const CampaignCarousel = createComponent('CampaignCarousel', ({ allowMarginBottom }) => ({
  position: 'relative',
  marginBottom: allowMarginBottom ? '24px' : '0px'
}))

const CampaignEntry = (props) => {
  const { item, config, theme, lazy, onTargetClick, locale, brand } = props
  const [infoHeight, setInfoHeight] = useState(0)
  const [loggedin, setLogin] = useState(false)
  const {
    teaserTitle,
    teaserText,
    pictures,
    target,
    ynapParameter,
    dataCmMetadata,
    fetchPriority,
    tags = '',
    targets,
    layoutVariant,
    analyticsTextString
  } = item
  const allowMuteOnVideo = hasTag(tags, 'Video.allowMute')
  const allowMid = hasTag(tags, 'Campaign.Mid')
  const allowSkinny = hasTag(tags, 'Campaign.Skinny')
  const allowSkinnySale = hasTag(tags, 'Campaign.SkinnySale')
  const allowMarginBottom = hasTag(tags, 'Campaign.MarginBottom')
  const allowCampaignBanner = hasTag(tags, 'Campaign.CampaignBanner')
  const loginPromo = layoutVariant === 'isc-campaign-takeover-login'

  useEffect(() => {
    if (loginPromo) {
      const getUser = async () => {
        const login = window && (await window.SF.getUserSummary())
        setLogin(login)
      }
      getUser()
    }
  }, [loggedin])

  const renderComp = (optimizely) => (
    <CampaignCarousel data-cm-metadata={dataCmMetadata} allowMarginBottom={allowMarginBottom}>
      <ImageBlock
        fetchPriority={fetchPriority}
        pictures={pictures}
        config={config}
        target={target}
        lazy={lazy}
        onTargetClick={onTargetClick}
        ynapParameter={ynapParameter}
        theme={theme}
        allowMid={allowMid}
        allowSkinny={allowSkinny}
        allowSkinnySale={allowSkinnySale}
        allowCampaignBanner={allowCampaignBanner}
        allowMute={allowMuteOnVideo}
        infoHeight={infoHeight}
      />
      <InfoBlock
        teaserTitle={teaserTitle}
        teaserText={teaserText}
        target={target}
        onTargetClick={onTargetClick}
        theme={theme}
        locale={locale}
        setInfoHeight={setInfoHeight}
        allowSkinny={allowSkinny}
        allowSkinnySale={allowSkinnySale}
        allowCampaignBanner={allowCampaignBanner}
        brand={brand?.brandId}
        targets={targets}
        layoutVariant={layoutVariant}
        loginPromo={loginPromo}
        optimizely={optimizely}
      />
    </CampaignCarousel>
  )

  return loginPromo ? (
    <OptimizelyFeature
      feature={[
        'web00612_loginprompt_homepage_desktop',
        'web00613_loginprompt_homepage_mobile',
        'web00610_loginprompt_homepage_desktop',
        'web00611_loginprompt_homepage_mobile'
      ]}
    >
      {(props) => {
        const { isEnabled, variationKey, optimizely } = props
        const [isOptimizelyLoading, setIsOptimizelyLoading] = useState(!!optimizely)
        const showVariant = analyticsTextString === variationKey
        optimizely?.onReady?.()?.then?.(() => {
          setIsOptimizelyLoading(false)
        })

        return !loggedin && !isOptimizelyLoading && isEnabled && showVariant ? renderComp(optimizely) : null
      }}
    </OptimizelyFeature>
  ) : (
    renderComp()
  )
}
CampaignEntry.layoutVariant = ['isc-campaign-takeover', 'isc-campaign-takeover-login']

CampaignEntry.propTypes = {
  item: shape({
    teaserTitle: string.isRequired,
    teaserText: string.isRequired,
    ynapParameter: string.isRequired,
    pictures: arrayOf(shape()).isRequired,
    target: shape({
      href: string.isRequired,
      teaserTitle: string.isRequired
    }),
    onTargetClick: func,
    dataCmMetadata: string
  }).isRequired,
  config: shape({
    imagesphere: shape()
  }),
  locale: shape({
    language: string.isRequired
  }).isRequired,
  theme: shape().isRequired,
  lazy: bool,
  brand: shape({
    brandId: string.isRequired
  }).isRequired
}

CampaignEntry.defaultProps = {
  item: {
    onTargetClick: () => {}
  },
  config: {
    imageShpere: {
      quality: 85
    },
    brightcove: {
      account: '88951765001',
      player: {
        regular: 'n0a1nFV70',
        soundless: 'HkVWbtmsM'
      }
    }
  },
  lazy: true
}

export default withTheme(CampaignEntry)
